import React from 'react';


const UserMenu = (props) => {
    return (
        <>
            <div className="vertical-line mx-4 h-6 bg-gray-400 hidden lg:block"></div>
            <div className="burger-menu">
                <a href={props.data.userAva[0].link}><img src={props.data.userAva[0].image}/></a>
            </div>
        </>
    );
};

export default UserMenu;